import angular from 'angular'

import { isProductActive } from './product-index-util'
import { ExactMatchIndex } from './exact-match-index'

/**
 * A search index for searching for active products by exact SKU match.
 *
 * @returns {ExactMatchIndex} The exact match index for searching for active products by SKU.
 */
export function productSkuIndexFactory() {
  return ExactMatchIndex.create({
    name: 'productSkuIndex',
    entityName: 'product',
    entityStoreName: 'products',
    databaseIndexName: 'byProductCode',
    filterResultsBy: isProductActive,
  })
}

export const productSkuIndex = productSkuIndexFactory()

export type ProductSkuIndex = ReturnType<typeof productSkuIndexFactory>

/**
 * A search index for searching for active products by exact SKU match.
 *
 * @module productSkuIndex
 */
angular
  .module('webregister.factories')
  .factory('productSkuIndex', () => productSkuIndex)
